export default "__VITE_ASSET__bbc99109__"